import {
  AllsetLogo, AllsetLogoInk, AllsetLogoWhite,
  CaviarLogo, CaviarLogoInk, CaviarLogoWhite,
  ChowNowMarkLogoInk, ChowNowMarkLogoWhite,
  CubohLogo, CubohLogoInk, CubohLogoWhite,
  DoorDashLogo, DoorDashLogoInk, DoorDashLogoWhite,
  EatStreetLogo, EatStreetLogoInk, EatStreetLogoWhite,
  FlipdishLogo, FlipdishLogoInk, FlipdishLogoWhite,
  FoodoraLogo, FoodoraLogoInk, FoodoraLogoWhite,
  FreshByteLogo, FreshByteLogoInk, FreshByteLogoWhite,
  GrubhubLogo, GrubhubLogoInk, GrubhubLogoWhite,
  MixbowlLogo, MixbowlLogoInk, MixbowlLogoWhite,
  ModuurnLogo, ModuurnLogoInk, ModuurnLogoWhite,
  PayarcLogo, PayarcLogoInk, PayarcLogoWhite,
  PostmatesLogo, PostmatesLogoInk, PostmatesLogoWhite,
  RitualLogo, RitualLogoInk, RitualLogoWhite,
  SkipTheDishesLogo, SkipTheDishesLogoInk, SkipTheDishesLogoWhite,
  SociavoreLogo, SociavoreLogoInk, SociavoreLogoWhite,
  UberEatsLogo, UberEatsLogoInk, UberEatsLogoWhite,
  CloverLogo, CloverLogoInk, CloverLogoWhite,
  GivexLogo, GivexLogoInk, GivexLogoWhite,
  HeartlandLogo, HeartlandLogoInk, HeartlandLogoWhite,
  LightspeedLogo, LightspeedLogoInk, LightspeedLogoWhite,
  MaitreDLogo, MaitreDLogoInk, MaitreDLogoWhite,
  ParLogo, ParLogoInk, ParLogoWhite,
  RevelLogo, RevelLogoInk, RevelLogoWhite,
  SquareLogo, SquareLogoInk, SquareLogoWhite,
  ToastLogo, ToastLogoInk, ToastLogoWhite,
} from '@chownow/pantry/logos';

import auphanColor from '@chownow/pantry/logos/auphan.png';
import auphanInk from '@chownow/pantry/logos/auphan-ink.png';
import auphanWhite from '@chownow/pantry/logos/auphan-white.png';
import ezcaterColor from '@chownow/pantry/logos/ezcater.png';
import ezcaterInk from '@chownow/pantry/logos/ezcater-ink.png';
import ezcaterWhite from '@chownow/pantry/logos/ezcater-white.png';
import mobilebytesColor from '@chownow/pantry/logos/mobilebytes.png';
import mobilebytesInk from '@chownow/pantry/logos/mobilebytes-ink.png';
import mobilebytesWhite from '@chownow/pantry/logos/mobilebytes-white.png';
import omnivoreColor from '@chownow/pantry/logos/omnivore.png';
import omnivoreInk from '@chownow/pantry/logos/omnivore-ink.png';
import omnivoreWhite from '@chownow/pantry/logos/omnivore-white.png';
import relayColor from '@chownow/pantry/logos/relay.png';
import relayInk from '@chownow/pantry/logos/relay-ink.png';
import relayWhite from '@chownow/pantry/logos/relay-white.png';
import silverwareColor from '@chownow/pantry/logos/silverware.png';
import silverwareInk from '@chownow/pantry/logos/silverware-ink.png';
import silverwareWhite from '@chownow/pantry/logos/silverware-white.png';
import skytabColor from '@chownow/pantry/logos/skytab.png';
import skytabInk from '@chownow/pantry/logos/skytab-ink.png';
import skytabWhite from '@chownow/pantry/logos/skytab-white.png';
import smoothcommerceColor from '@chownow/pantry/logos/smooth-commerce.png';
import smoothcommerceInk from '@chownow/pantry/logos/smooth-commerce-ink.png';
import smoothcommerceWhite from '@chownow/pantry/logos/smooth-commerce-white.png';
import volanteColor from '@chownow/pantry/logos/volante.png';
import volanteInk from '@chownow/pantry/logos/volante-ink.png';
import volanteWhite from '@chownow/pantry/logos/volante-white.png';

export default {
  allset: {
    color: AllsetLogo,
    ink: AllsetLogoInk,
    white: AllsetLogoWhite,
  },
  caviar: {
    color: CaviarLogo,
    ink: CaviarLogoInk,
    white: CaviarLogoWhite,
  },
  chownow: {
    color: ChowNowMarkLogoInk,
    ink: ChowNowMarkLogoInk,
    white: ChowNowMarkLogoWhite,
  },
  cuboh: {
    color: CubohLogo,
    ink: CubohLogoInk,
    white: CubohLogoWhite,
  },
  doordash: {
    color: DoorDashLogo,
    ink: DoorDashLogoInk,
    white: DoorDashLogoWhite,
  },
  eatstreet: {
    color: EatStreetLogo,
    ink: EatStreetLogoInk,
    white: EatStreetLogoWhite,
  },
  ezcater: {
    color: ezcaterColor,
    ink: ezcaterInk,
    white: ezcaterWhite,
    type: 'png',
  },
  flipdish: {
    color: FlipdishLogo,
    ink: FlipdishLogoInk,
    white: FlipdishLogoWhite,
  },
  foodora: {
    color: FoodoraLogo,
    ink: FoodoraLogoInk,
    white: FoodoraLogoWhite,
  },
  freshbytes: {
    color: FreshByteLogo,
    ink: FreshByteLogoInk,
    white: FreshByteLogoWhite,
  },
  grubhub: {
    color: GrubhubLogo,
    ink: GrubhubLogoInk,
    white: GrubhubLogoWhite,
  },
  kiosk: {
    color: CubohLogo,
    ink: CubohLogoInk,
    white: CubohLogoWhite,
  },
  mixbowl: {
    color: MixbowlLogo,
    ink: MixbowlLogoInk,
    white: MixbowlLogoWhite,
  },
  moduurn: {
    color: ModuurnLogo,
    ink: ModuurnLogoInk,
    white: ModuurnLogoWhite,
  },
  payarc: {
    color: PayarcLogo,
    ink: PayarcLogoInk,
    white: PayarcLogoWhite,
  },
  postmates: {
    color: PostmatesLogo,
    ink: PostmatesLogoInk,
    white: PostmatesLogoWhite,
  },
  relay: {
    color: relayColor,
    ink: relayInk,
    white: relayWhite,
    type: 'png',
  },
  ritual: {
    color: RitualLogo,
    ink: RitualLogoInk,
    white: RitualLogoWhite,
  },
  skip: {
    color: SkipTheDishesLogo,
    ink: SkipTheDishesLogoInk,
    white: SkipTheDishesLogoWhite,
  },
  smoothcommerce: {
    color: smoothcommerceColor,
    ink: smoothcommerceInk,
    white: smoothcommerceWhite,
    type: 'png',
  },
  sociavore: {
    color: SociavoreLogo,
    ink: SociavoreLogoInk,
    white: SociavoreLogoWhite,
  },
  ubereats: {
    color: UberEatsLogo,
    ink: UberEatsLogoInk,
    white: UberEatsLogoWhite,
  },
  // POS logos
  often: {
    color: auphanColor,
    ink: auphanInk,
    white: auphanWhite,
    type: 'png',
  },
  clover: {
    color: CloverLogo,
    ink: CloverLogoInk,
    white: CloverLogoWhite,
  },
  givex: {
    color: GivexLogo,
    ink: GivexLogoInk,
    white: GivexLogoWhite,
  },
  heartland: {
    color: HeartlandLogo,
    ink: HeartlandLogoInk,
    white: HeartlandLogoWhite,
  },
  lightspeed: {
    color: LightspeedLogo,
    ink: LightspeedLogoInk,
    white: LightspeedLogoWhite,
  },
  mdproxy: {
    color: MaitreDLogo,
    ink: MaitreDLogoInk,
    white: MaitreDLogoWhite,
  },
  mobilebytes: {
    color: mobilebytesColor,
    ink: mobilebytesInk,
    white: mobilebytesWhite,
    type: 'png',
  },
  omnivore: {
    color: omnivoreColor,
    ink: omnivoreInk,
    white: omnivoreWhite,
    type: 'png',
  },
  revel: {
    color: RevelLogo,
    ink: RevelLogoInk,
    white: RevelLogoWhite,
  },
  shift4: {
    color: skytabColor,
    ink: skytabInk,
    white: skytabWhite,
    type: 'png',
  },
  shooterpp: {
    color: ParLogo,
    ink: ParLogoInk,
    white: ParLogoWhite,
  },
  silverware: {
    color: silverwareColor,
    ink: silverwareInk,
    white: silverwareWhite,
    type: 'png',
  },
  square: {
    color: SquareLogo,
    ink: SquareLogoInk,
    white: SquareLogoWhite,
  },
  toast: {
    color: ToastLogo,
    ink: ToastLogoInk,
    white: ToastLogoWhite,
  },
  volante: {
    color: volanteColor,
    ink: volanteInk,
    white: volanteWhite,
    type: 'png',
  },
};
